export default {
  data() {
    return {
      timeoutInMS: 30 * 60 * 1000, // default fallback before reading session from API
      warningTimeInMS: 20 * 60 * 1000, // default warning threshold for 30-minute timeout
      timeoutId: null,
      warningId: null,
      activeTimeouts: [],
      timeLeft: 0, // milliseconds left until session expires
      countdownIntervalId: null,
      lastResetTimestamp: 0,
      activityEvents: ["mousemove","keydown", "click", "scroll"],
      throttleDelay: 1000,
      lastResetTime: 0,
    };
  },
  methods: {
    async initSession() {
      try {
        const response = await fetch(
          `${process.env.VUE_APP_API_BASE_URL}/session/get/session`,
          { method: "GET", credentials: "include" }
        );
        const session = await response.json();
        this.timeoutInMS = parseInt(session.timeOut);
        this.warningTimeInMS = (this.timeoutInMS * 2) / 3;

        this.startSessionTimers();
        this.addActivityListeners();
      } catch (err) {
        console.error("Session init failed:", err);
      }
    },

    startSessionTimers() {
      this.clearAllTimeouts();

      this.warningId = setTimeout(this.showSessionWarning, this.warningTimeInMS);
      this.timeoutId = setTimeout(this.logOut, this.timeoutInMS);

      this.activeTimeouts.push(this.warningId, this.timeoutId);

      this.lastResetTimestamp = Date.now();

      // Start countdown interval to update timeLeft every second
      if (this.countdownIntervalId) clearInterval(this.countdownIntervalId);
      this.countdownIntervalId = setInterval(() => {
        const elapsed = Date.now() - this.lastResetTimestamp;
        this.timeLeft = Math.max(this.timeoutInMS - elapsed, 0);
        console.log(
          `Session time left: ${Math.floor(this.timeLeft / 1000)} seconds`
        );
      }, 1000);
    },

    clearAllTimeouts() {
      this.activeTimeouts.forEach((id) => clearTimeout(id));
      this.activeTimeouts = [];

      if (this.countdownIntervalId) {
        clearInterval(this.countdownIntervalId);
        this.countdownIntervalId = null;
      }
    },

    addActivityListeners() {
      this.activityEvents.forEach((event) =>
        window.addEventListener(event, this.throttledResetSessionDueToActivity)
      );
    },

    throttledResetSessionDueToActivity() {
      const now = Date.now();
      if (now - this.lastResetTime > this.throttleDelay) {
        this.lastResetTime = now;
        this.resetSessionDueToActivity();
      }
    },

    resetSessionDueToActivity() {
      console.log("👋 Activity detected, resetting session");
      this.clearAllTimeouts();
      this.resetSessionExpiration();
    },

    async resetSessionExpiration() {
      try {
        await fetch(`${process.env.VUE_APP_API_BASE_URL}/session/reset/session`, {
          method: "POST",
          credentials: "include",
        });
        this.startSessionTimers();
      } catch (err) {
        console.error("❌ Failed to extend session", err);
      }
    },

    showSessionWarning() {
      alert("⚠️ Session will expire soon");
    },

    async logOut() {
      try {
        await fetch(`${process.env.VUE_APP_API_BASE_URL}/session/logout`, {
          method: "GET",
          credentials: "include",
        });
        this.$router.replace({ path: "/login", query: { logout: "1" } });
      } catch (err) {
        console.error("Logout failed", err);
        this.$router.replace({ path: "/login", query: { logout: "1" } });
      }
    },
  },

  beforeUnmount() {
    this.clearAllTimeouts();
    this.activityEvents.forEach((event) =>
      window.removeEventListener(event, this.throttledResetSessionDueToActivity)
    );
  },
};
